import { DateElement, ElementIdThickness } from "projects/phdsoft/common/src/lib/models/referencedate-request.model";
import { MaterialType } from "../ResourceElements/MaterialType";
import { LinearElement } from "../SectionElements/StructureElements/LinearElement";
import { StructuralElement } from "../SectionElements/StructureElements/StructuralElement";
import { SurfaceElement } from "../SectionElements/StructureElements/SurfaceElement";
import { Collection } from "./Collection";
import { StructureDegradationParameters } from "src/app/degradation/models/degradation-curve";
import * as THREE from '@phdsoft/three';

export class StructureCollection extends Collection {
    private _DatePosCoating: Date;
    public get DatePosCoating(): Date {
        return this._DatePosCoating;
    }
    public set DatePosCoating(v: Date) {
        this._DatePosCoating = v;
    }

    private _IsOriginal: boolean;
    public get IsOriginal(): boolean {
        return this._IsOriginal;
    }
    public set IsOriginal(v: boolean) {
        this._IsOriginal = v;
    }

    private _isPropertiesLoaded: boolean;
    public get isPropertiesLoaded(): boolean {
        return this._isPropertiesLoaded;
    }

    constructor(date: Date) {
        super(date);
        this.Date = new Date(date);
        this.isGroupRecursive = true;
        this.Type = "StructureCampaign";
    }
    
    public addSurfaceStructureElement(structure: SurfaceElement, addToGroup: boolean = true) {
        if(!structure.SectionId){
            var region = this.regionsWorkableElements.find(x => x.Guid === structure.regionId);
            if(region){
                if (addToGroup) region.group.add((structure).SurfaceDesign);
                region.surfaceElements.push(structure);
            }
        }
        else{
            this.regionsWorkableElements.find(x => x.Guid === structure.regionId)?.sections.
                find(x => x.Guid === structure.SectionId)?.addSurfaceElement(structure, addToGroup);
            structure.Campaign = this;
        }
    }

    public addLinearStructureElement(structure: LinearElement, addToGroup: boolean = true) {
        this.regionsWorkableElements.find(x => x.Guid === structure.regionId)?.sections.
            find(x => x.Guid === structure.SectionId)?.addLinearElement(structure, null, addToGroup);
        structure.Campaign = this;
    }

    public setElementsProperties(regionId: string, elementsProperties: any, materials: Array<MaterialType>): void {
        const region = this.regionsWorkableElements.find(x => x.Guid === regionId);
        if (region) {
            region.setElementsProperties(elementsProperties, materials);
            this._isPropertiesLoaded = true;
        }
    }

    public clearElementsProperties() {
        for (const region of this.regionsWorkableElements) {
            region.clearElementsProperties();
            this._isPropertiesLoaded = false;
        }
    }

    public updateDegradationColors(degradationCurves: StructureDegradationParameters[]): void {
        for (const region of this.regionsWorkableElements) {
            region.updateDegradationColors(degradationCurves);
        }
    }

    public updateRemainingLifeViewMode(low: number, high: number, degradationCurves: StructureDegradationParameters[]): void {
        for (const region of this.regionsWorkableElements) {
            region.updateRemainingLifeViewMode(low, high, degradationCurves);
        }
    }

    public updateCorrosionRateViewMode(low: number, high: number, degradationCurves: StructureDegradationParameters[]): void {
        for (const region of this.regionsWorkableElements) {
            region.updateCorrosionRateViewMode(low, high, degradationCurves);
        }
    }

    public updateCorrosionRiskIndexViewMode(low: number, high: number, degradationCurves: StructureDegradationParameters[]): void {
        for (const region of this.regionsWorkableElements) {
            region.updateCorrosionRiskIndexViewMode(low, high, degradationCurves);
        }
    }

    // public getCorrosionRateParameters(): number[] {
    //     var corrosionRateList: number[] = []
    //     for (const region of this.regionsWorkableElements) {
    //         corrosionRateList.concat(region.getCorrosionRateParameters());
    //     }
    //     return corrosionRateList.sort()
    // }

    public changeStructureMaterials(material: THREE.Material): void {
        for (const surfaceElement of this.SurfaceElements) {
            // Preserve elements that carry a custom material (the per-element
            // material editor). Without this guard, mode entries like CUTPLATE
            // (which calls resetStructureMaterials -> changeStructureMaterials)
            // would visually wipe the custom appearance even though the
            // customMaterial slot is still set.
            if ((surfaceElement as any).customMaterial) continue;
            surfaceElement.currentRenderMaterial = material;
        }
    }

    public resetMaterials() {
        this.Elements.forEach(element => {
            if ((element as any).customMaterial) return;
            element.SurfaceDesign.material = element.defaultMaterial
            element.currentMaterial = element.defaultMaterial
        })
    }

    public GetElementsDate(): DateElement {
        const elementsIds: DateElement = { Date: this.Date, ElementsIdsThickness: [] };

        for (const region of this.regionsWorkableElements) {
            for (const section of region.sections) {
                for (const element of section.surfaceElements) {
                    const idThickness: ElementIdThickness = { ElementId: element.Guid, Thickness: (element as StructuralElement).thickness };
                    elementsIds.ElementsIdsThickness.push(idThickness);
                }
                // for (const element of section.linearElements) {
                //     const idThickness: ElementIdThickness = { ElementId: element.Guid, Thickness: (element as StructuralElement).thickness };
                //     elementsIds.ElementsIdsThickness.push(idThickness);
                // }
            }
        }

        // for (const _group of this.StructureGroups) {
        //     for (const _child of _group.children) {
        //         let thickness = null;
        //         if (this.graphics.propertiesNavigator.ElementProperties) {
        //             const property = this.graphics.propertiesNavigator.ElementProperties.find(x => x.ElementId === _child.userData.Guid ||
        //                 x.ElementId.replace(/-/g, '') === _child.userData.Guid);
        //             if (!Util.isNullOrUndefined(property) && property.Geometry) {
        //                 thickness = property.Geometry.Thickness;
        //             }
        //         }
        //         const idThickness: ElementIdThickness = { ElementId: _child.userData.Guid, Thickness: thickness }
        //         elementsIds.ElementsIdsThickness.push(idThickness);
        //     }
        // }
        return elementsIds;
    }
}
